export enum ELanguege {
    EN = "en",
    VN = "vn",
}